export default {
  name: "Step4",
  props: ['userList'],
  components: {},
  data: function data() {
    return {
      loading: false,
      time: 0
    };
  },
  methods: {
    countDown: function countDown() {
      var that = this;
      that.time--;
    }
  },
  mounted: function mounted() {
    var that = this;
    that.time = 5;
    setInterval(that.countDown, 1000);
  },
  watch: {
    time: function time(newVal, oldVal) {
      if (newVal == 0) {
        var params = {
          username: this.userList.username
        };
        this.$router.push({
          name: 'login',
          params: params
        });
      }
    }
  }
};